import {
  PageHeader,
  Loading,
  toastSuccessMessage,
  updateUserCurrentStep,
} from "wup-module1-base";
import { useParams, useNavigate } from "react-router-dom";
import { PageTitleConstants, RoutePathConstants } from "../../Constants";
import { Card } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import UserContext from "../../Contexts/UserContext";
import { StoreService } from "../../Services";
import { WindowExclusiveOption } from "../../Components";
import { toast } from "react-toastify";
import { AuthService } from "../../Services";

function StoreExclusiveSummary() {
  const nexSuccessMessage = "Zatwierdzono ofertę";
  const nexErrorOfferMessage = "Nie wybrano żadnej oferty";
  const nexErrorBookingMessage = "Nie wybrano terminu spotkania";
  const { uuId } = useParams();
  const { user, setUser } = useContext(UserContext);
  const [isSubmittinginfo, setIsSubmittingInfo] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [careerName, setCareerName] = useState("Żadnej z usług dodatkowych");
  const navigate = useNavigate();

  const storedData = sessionStorage.getItem("storeData");
  const [parsedData, setParsedData] = useState(JSON.parse(storedData));

  //fetch aktualnych danych klienta
  const fetchUserData = () => {
    AuthService.getUserData()
      .then((response) => {
        const updatedUser = updateUserCurrentStep(
          user, 
          response.data.status,
          response.data.clientStep
        );
        setUser(updatedUser);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    StoreService.getOrder(user.id)
      .then((response) => {
        if (!parsedData) {
          const dataResponse = {
            offer: response.data.exclusive_item_id,
          };
          sessionStorage.setItem("storeData", JSON.stringify(dataResponse));
          setParsedData(dataResponse);
        }
      })
      .catch((error) => {
        console.error(error);
      });

    setIsSubmittingInfo(true);
    StoreService.storeItems()
      .then((response) => {
        let fundingOffer = response.data.find(
          (item) => item.id === parsedData.offer
        );
        if (fundingOffer != undefined || fundingOffer != null) {
          setCareerName(fundingOffer.name);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsSubmittingInfo(false);
      });
  }, []);

  function goSubmit() {
    setIsSubmitting(true);
    if (parsedData !== null) {
      const dataStore = {
        exclusiveItemId: parsedData.offer,
        bookingId: parseInt(parsedData.bookingId),
      };

      if (
        dataStore.exclusiveItemId == null ||
        dataStore.exclusiveItemId == undefined ||
        dataStore.exclusiveItemId == 0
      ) {
        toast.error(nexErrorOfferMessage);
        return;
      }

      if (
        dataStore.bookingId == null ||
        dataStore.bookingId == undefined ||
        dataStore.bookingId == 0
      ) {
        toast.error(nexErrorBookingMessage);
        return;
      }

      StoreService.storeExclusiveOrder(user.id, dataStore)
        .then((response) => {
          toastSuccessMessage(nexSuccessMessage);
          fetchUserData();
          sessionStorage.clear();
          navigate(`/`);
        })
        .catch((error) => {
          if (
            error.response?.status === 400 ||
            error.response?.status === 422
          ) {
            toast.error(
              <div>
                Usługa ekskluzywna {careerName} w wybranym terminie jest już
                niedostępna.
              </div>,
              {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              }
            );
          }

          let storedData = sessionStorage.getItem("storeData");
          let dataObject = JSON.parse(storedData);
          delete dataObject.offer;
          delete dataObject.bookingId;
          setParsedData(dataObject);
          let updatedData = JSON.stringify(dataObject);
          sessionStorage.setItem("storeData", updatedData);
          setCareerName("Żadnej z usług dodatkowych");
          console.error(error);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  }

  function goBack() {
    navigate(`/${RoutePathConstants.StoreExclusive}/${uuId}`);
  }

  return (
    <>
      <PageHeader content={PageTitleConstants.StoreSummary} />
      <Card>
        <Card.Body>
          <div className="pt-4-5 background_4">
            {isSubmittinginfo || !parsedData ? (
              <Loading size="lg" className="px-10" variant="light" />
            ) : (
              <>
                <WindowExclusiveOption
                  parsedData={parsedData}
                  careerName={careerName}
                />
                <div className="title-3 pt-4-5">
                  Czy potwierdzasz swoją decyzję?
                </div>
                <div className="button-box-summary">
                  <button
                    variant="primary"
                    className="button-confirm-2"
                    disabled={isSubmitting}
                    onClick={goSubmit}
                  >
                    {isSubmitting ? (
                      <Loading size="sm" className="px-3" variant="light" />
                    ) : (
                      <>Tak, potwierdzam</>
                    )}
                  </button>

                  <button className="button-confirm-2" onClick={goBack}>
                    Nie, chcę zmienić wybór
                  </button>
                </div>
              </>
            )}
          </div>
        </Card.Body>
      </Card>
    </>
  );
}

export default StoreExclusiveSummary;
